// Business identity + bank details shown on invoices and anywhere the app
// tells clients how to pay. No secrets here — API keys stay server-side in
// Cloud Functions config, never in this file.

export const BUSINESS = {
  name: 'Garden & Groundworks',
  tagline: 'Gardens · Landscaping · Groundworks',
  email: 'info@gandg.gg',
  phone: '07839 282633',
  website: 'gandg.gg',
  address: 'Le Val Farm, Route Des Blicqs, St Andrew, Guernsey, GY6 8YD',
};

export const BANK_DETAILS = {
  bankName: 'Lloyds Bank',
  accountName: 'D Patterson',
  sortCode: '30-93-73',
  accountNumber: '16568168',
};

// PLACEHOLDER — replace with the real Instagram handle/URL before this is
// meaningful to visitors.
export const INSTAGRAM_URL = 'https://instagram.com/REPLACE_ME';
